import React, { useState, useRef } from "react";

const Testingvide = () => {
  const [duration, setDuration] = useState("");
  const [scenes, setScenes] = useState([]);
  const [mergedVideo, setMergedVideo] = useState(null);
  const [merging, setMerging] = useState(false);
  const videoRef = useRef(null);

  const handleGenerateScenes = () => {
    if (!duration || duration <= 0) return;
    const sceneCount = Math.ceil(parseInt(duration) / 8);
    const generatedScenes = Array.from({ length: sceneCount }, (_, i) => ({
      id: i + 1,
      prompt: "",
      videoUrl: null,
      loading: false,
      error: null,
    }));
    setScenes(generatedScenes);
  };

  const handlePromptChange = (index, value) => {
    const updated = [...scenes];
    updated[index].prompt = value;
    setScenes(updated);
  };

  // Example: "generate" scene by assigning local public video
  const handleGenerateSceneVideo = async (index) => {
    const updated = [...scenes];
    updated[index].loading = true;
    updated[index].error = null;
    setScenes(updated);

    try {
      await new Promise((res) => setTimeout(res, 500)); // simulate API delay

      // **Use your local public videos here**
      const localVideos = ["/1.mp4", "/2.mp4"];
      const videoUrl = localVideos[index % localVideos.length]; // loop through videos if more scenes

      updated[index].videoUrl = videoUrl;
      updated[index].loading = false;
      setScenes([...updated]);
    } catch (err) {
      updated[index].loading = false;
      updated[index].error = "Failed to generate video";
      setScenes([...updated]);
    }
  };

  // ---------------- FRONTEND MERGE FUNCTION ----------------
  const handleMergeVideos = async () => {
    const videoUrls = scenes.filter((s) => s.videoUrl).map((s) => s.videoUrl);
    if (!videoUrls.length) return alert("Generate all scene videos first!");

    setMerging(true);

    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    const stream = canvas.captureStream();
    const recorder = new MediaRecorder(stream, { mimeType: "video/webm" });
    const chunks = [];

    recorder.ondataavailable = (e) => chunks.push(e.data);
    recorder.start();

    for (let i = 0; i < videoUrls.length; i++) {
      await playVideoOnCanvas(videoUrls[i], canvas, ctx);
    }

    recorder.stop();

    recorder.onstop = () => {
      const blob = new Blob(chunks, { type: "video/webm" });
      setMergedVideo(URL.createObjectURL(blob));
      setMerging(false);
    };
  };

  const playVideoOnCanvas = (videoUrl, canvas, ctx) =>
    new Promise((resolve) => {
      const video = document.createElement("video");
      video.src = videoUrl;
      video.muted = true;
      video.play();

      video.onloadedmetadata = () => {
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;

        const drawFrame = () => {
          ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
          if (!video.paused && !video.ended) requestAnimationFrame(drawFrame);
        };
        drawFrame();
      };

      video.onended = () => resolve();
    });

  const handleDownload = (url, name) => {
    const a = document.createElement("a");
    a.href = url;
    a.download = name;
    a.click();
  };

  return (
    <div style={{ padding: "20px" }}>
      <h2>Smart Video Creator (Frontend Merge)</h2>

      <div style={{ marginBottom: "20px" }}>
        <input
          type="number"
          placeholder="Duration in seconds"
          value={duration}
          onChange={(e) => setDuration(e.target.value)}
        />
        <button onClick={handleGenerateScenes}>Divide into Scenes</button>
      </div>

      {scenes.map((scene, idx) => (
        <div key={scene.id} style={{ marginBottom: "10px" }}>
          <input
            placeholder={`Scene ${scene.id}`}
            value={scene.prompt}
            onChange={(e) => handlePromptChange(idx, e.target.value)}
          />
          <button
            onClick={() => handleGenerateSceneVideo(idx)}
            disabled={scene.loading}
          >
            {scene.loading ? "Generating..." : "Generate Scene"}
          </button>

          {scene.videoUrl && (
            <div>
              <video src={scene.videoUrl} width="300" controls />
            </div>
          )}
        </div>
      ))}

      {scenes.length > 0 && (
        <div style={{ marginTop: "20px" }}>
          <button onClick={handleMergeVideos} disabled={merging}>
            {merging ? "Merging..." : "Merge All Scenes"}
          </button>
        </div>
      )}

      {mergedVideo && (
        <div style={{ marginTop: "20px" }}>
          <h3>Merged Video</h3>
          <video src={mergedVideo} width="600" controls autoPlay />
          <div>
            <button
              onClick={() => handleDownload(mergedVideo, "merged-video.webm")}
            >
              Download
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Testingvide;
